/**
 * Responsive breakpoint tokens.
 *
 * These are the *single source of truth* for viewport breakpoints across
 * the app. Prefer these over magic-number `@media` queries so that
 * mobile/tablet/desktop thresholds stay consistent.
 *
 * In the Tailwind-first end state, prefer Tailwind's responsive variants
 * (`sm:`, `md:`, `lg:`, etc.) which map to these same values. For inline
 * `@media` rules inside module CSS or <style> blocks, use
 * `mediaQueries.mobile` etc. below.
 */

export const breakpoints = Object.freeze({
  /** Phone (≤480px) */
  mobile: '480px',
  /** Phone-to-tablet boundary; treat anything ≤768px as "mobile layout" */
  tablet: '768px',
  /** Tablet-to-desktop boundary; treat anything ≥1024px as "desktop layout" */
  desktop: '1024px',
  /** Wide desktop (≥1280px) */
  wide: '1280px',
});

/**
 * Pre-baked `@media` query strings for the most common cases. These match
 * the pattern already used in places like `routes/Login` so we can refactor
 * those incrementally without changing behaviour.
 */
export const mediaQueries = Object.freeze({
  /** Apply when viewport is mobile/small-tablet (≤768px). */
  mobile: `@media (max-width: ${breakpoints.tablet})`,
  /** Apply when viewport is tablet or smaller (≤1024px). */
  tablet: `@media (max-width: ${breakpoints.desktop})`,
  /** Apply when viewport is desktop or larger (≥1024px). */
  desktop: `@media (min-width: ${breakpoints.desktop})`,
  /** Apply when viewport is wide desktop (≥1280px). */
  wide: `@media (min-width: ${breakpoints.wide})`,
});
